var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlexLayout',[_c('BlockContainer',{scopedSlots:_vm._u([{key:"actions",fn:function(){return _vm._l((_vm.links),function(item){return _c('div',{key:item.key},[_c('Button',{staticClass:"dashboard-item",attrs:{"icon-left":item.icon,"action":item.action,"lg":""}},[_vm._v(_vm._s(item.name()))])],1)})},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }